import { useSiteConfig } from '../../../hooks/useSiteConfig';
import { SiteFiling } from '../../../components/common/SiteFiling';

/**
 * 活动页共用的对外外壳（顶部导航 + 页脚备案）。
 *
 * 只给 /activity 与 /activity/:key 两页用：现有公开页（/about、/download 等）各写各的导航是历史形态，
 * 这次不去动它们，但新页面内部不再复制第二份——两页的导航与页脚一模一样。
 */
export function ActivityShell({ children }: { children: React.ReactNode }) {
  const { siteName, logoUrl } = useSiteConfig();

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <nav className="sticky top-0 z-50 h-[70px] bg-white/95 backdrop-blur-md border-b border-slate-100">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 h-full flex items-center justify-between">
          <a href="/" className="flex items-center gap-3">
            <img src={logoUrl} alt="Logo" className="w-10 h-10" />
            <span className="text-lg font-bold tracking-wide text-slate-800">{siteName}</span>
          </a>
          <div className="flex items-center gap-6">
            <a href="/" className="text-sm font-medium text-slate-600 hover:text-teal-600 transition-colors">
              首页
            </a>
            <a href="/help" className="text-sm font-medium text-slate-600 hover:text-teal-600 transition-colors">
              帮助中心
            </a>
            <a href="/download" className="text-sm font-medium text-slate-600 hover:text-teal-600 transition-colors">
              下载 App
            </a>
            <a
              href="/register"
              className="text-sm font-medium px-5 py-2 rounded-full bg-teal-600 text-white hover:bg-teal-700 transition-colors"
            >
              注册账号
            </a>
          </div>
        </div>
      </nav>

      <main className="flex-1 py-14">{children}</main>

      <footer className="bg-slate-800 text-slate-300 py-8 px-6 text-xs">
        <SiteFiling />
      </footer>
    </div>
  );
}

/** 面包屑：活动列表是这一区的根，详情页在其上多一层 */
export function ActivityCrumb({ current }: { current: string }) {
  return (
    <div className="text-xs text-slate-500 mb-8">
      <a href="/" className="hover:text-teal-600 transition-colors">
        首页
      </a>
      <span className="mx-2">/</span>
      <a href="/activity" className="hover:text-teal-600 transition-colors">
        最新活动
      </a>
      {current && (
        <>
          <span className="mx-2">/</span>
          <span className="text-slate-700">{current}</span>
        </>
      )}
    </div>
  );
}
